// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"style__pageWrapper__rIqOA"};